export const eventTypes = {
    DIFF_TIME: 'diffTime',
    DIFF_DAY: 'diffDay',
    DIFF_DATE: 'diffDate',
    PERIODIC_DAILY: 'periodicDaily',
    PERIODIC_WEEKLY: 'periodicWeekly',
    PERIODIC_MONTHLY: 'periodicMonthly',
    SINGLE: 'single',
    WEEKLY: 'weekly'
}